exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\r\n\r\n.contenedor-principal{\r\n  \r\n    position: relative;\r\n    padding-bottom: 10px;\r\n    text-align: left;\r\n}\r\n\r\n.titulo-principal{\r\n    margin: 0px;\r\n    font-weight: bold;\r\n    color: #004d9b;\r\n    text-shadow: 2px 2px 0px #FFFFFF, 5px 4px 0px rgba(0,0,0,0.15);\r\n    margin-bottom: 10px;\r\n    text-align: center;\r\n\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/portal/components/contenedor-aplicaciones/aplicaciones/aplicaciones-generales.style.css
// module id = 634
// module chunks = 0